import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baclgroundInfo: [],
    ConfigData: {},
    floorData: [],
    setLoading:false,
    setMoveOne:false,
    setMoveTwo:false,
    logoFlag:false,
  },
  mutations: {
    setlogoFlag(state,value){
      state.logoFlag = value
    },
    setLoading(state, value) {
      state.loading = value;
    },
    baclgroundInfo(state, value) {
      state.baclgroundInfo = value;
    },
    ConfigData(state, value) {
      state.ConfigData = value;
    },
    floorData(state, value) {
      state.floorData = value;
    },
    setMoveOne(state, value) {
      state.moveOne = value;
    },
    setMoveTwo(state, value) {
      state.moveTwo = value;
    },
  },
  actions: {
  },
  modules: {
  }
})
